// src/i18n.js
// Инициализация i18next. Импортировать один раз в index.js ДО рендера <App/>.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from './locales/ru/translation.json';
import kk from './locales/kk/translation.json';
import en from './locales/en/translation.json';

i18n
  .use(LanguageDetector) // сначала смотрит localStorage; если пусто — берёт fallbackLng (русский)
  .use(initReactI18next)
  .init({
    resources: {
      kk: { translation: kk },
      ru: { translation: ru },
      en: { translation: en },
    },
    fallbackLng: 'ru',
    supportedLngs: ['kk', 'ru', 'en'],
    interpolation: {
      escapeValue: false, // React сам экранирует
    },
    detection: {
      // Без 'navigator': язык браузера не должен переопределять дефолт (русский).
      // Только явный выбор пользователя (сохранённый в localStorage) меняет язык.
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'isv_lang',
    },
  });

export default i18n;
